import {
    getCourseDetails,
    getUserCourses,
    getUserCourseGroups,
    getTopics,
    getSubjects,
    getFilteredCourses,
    getAllUserCourses,
    addToCourseApi,
} from "../services/courseService";

export const getCourseList = (id, skipCourse = 0, courseLength = 20, search= "") => (dispatch) => {
    dispatch(request());
    return getAllUserCourses(id, skipCourse, courseLength, search)
        .then((response) => {
            // handle success
            dispatch(success(response));
            return response;
        })
        .catch((error) => {
            // handle error
            dispatch(failure(error.toString()));
        });

    function request() {
        return { type: "COURSE_LIST_REQUEST" };
    }

    function success(response) {
        return { type: "COURSE_LIST_SUCCESS", payload: response, skipCourse, search };
    }

    function failure(error) {
        return { type: "COURSE_LIST_FAILURE", payload: error };
    }
};

export const addToCoures = (courseId, userId) => (dispatch) => {
    dispatch(request());
    return addToCourseApi(courseId, userId)
        .then((response) => {
            // handle success
            dispatch(success(response));
            return response;
        })
        .catch((error) => {
            // handle error
            dispatch(failure(error.toString()));
        });

    function request() {
        return { type: "ADD_TO_COURSE_REQUEST" };
    }

    function success(response) {
        return { type: "ADD_TO_COURSE_SUCCESS", payload: response };
    }

    function failure(error) {
        return { type: "ADD_TO_COURSE_FAILURE", payload: error };
    }
};

export const getCourse = (courseId) => (dispatch) => {
    dispatch(request());
    getCourseDetails(courseId)
        .then((response) => {
            // handle success
            dispatch(success(response));
            return response;
        })
        .catch((error) => {
            // handle error
            dispatch(failure(error.toString()));
        });

    function request() {
        return { type: "COURSE_REQUEST" };
    }

    function success(response) {
        return { type: "COURSE_SUCCESS", payload: response };
    }

    function failure(error) {
        return { type: "COURSE_FAILURE", payload: error };
    }
};

export const getUserCourse = (userId, skip = 0, limit = 20, search= "") => (dispatch) => {
    dispatch(request());
    return getUserCourses(userId, skip, limit, search)
        .then((response) => {
            // handle success
            dispatch(success(response));
            dispatch(setActive(response));
            return response;
        })
        .catch((error) => {
            // handle error
            dispatch(failure(error.toString()));
        });

    function request() {
        return { type: "USER_COURSE_REQUEST" };
    }

    function success(response) {
        return { type: "USER_COURSE_SUCCESS", payload: response, skip, search };
    }

    function setActive(response) {
        return dispatch({
            type: "SELECT_USER_COURSE_SUCCESS",
            payload: response.data[0].courses[0],
        });
    }

    function failure(error) {
        return { type: "USER_COURSE_FAILURE", payload: error };
    }
};

export const getUserCourseGroup = (skip = 0, limit = 20, search = "") => (dispatch) => {
    dispatch(request());
    return getUserCourseGroups(limit, skip, search)
        .then((response) => {
            dispatch(success(response));
            return response;
        })
        .catch((error) => {
            dispatch(failure(error.toString()));
        });

    function request() {
        return { type: "USER_COURSE_GROUP_REQUEST" };
    }

    function success(response) {
        return { type: "USER_COURSE_GROUP_SUCCESS", payload: response, skip, search };
    }

    function failure(error) {
        return { type: "USER_COURSE_GROUP_FAILURE", payload: error };
    }
};

export const getCourseSubjects = (courseId) => (dispatch) => {
    dispatch(request());
    getSubjects(courseId)
        .then((response) => {
            // handle success
            dispatch(success(response));
        })
        .catch((error) => {
            // handle error
            dispatch(failure(error.toString()));
        });

    function request() {
        return { type: "SUBJECT_REQUEST" };
    }

    function success(response) {
        return { type: "SUBJECT_SUCCESS", payload: response };
    }

    function failure(error) {
        return { type: "SUBJECT_FAILURE", payload: error };
    }
};

export const getCourseTopics = (courseId, subjectId) => (dispatch) => {
    dispatch(request());
    getTopics(courseId, subjectId)
        .then((response) => {
            // handle success
            dispatch(success(response));
        })
        .catch((error) => {
            // handle error
            dispatch(failure(error.toString()));
        });

    function request() {
        return { type: "TOPIC_REQUEST" };
    }

    function success(response) {
        return { type: "TOPIC_SUCCESS", payload: response };
    }

    function failure(error) {
        return { type: "TOPIC_FAILURE", payload: error };
    }
};

export const getFilteredCourseList = (id, examId) => (dispatch) => {
    dispatch(request());
    getFilteredCourses(id, examId)
        .then((response) => {
            // handle success
            dispatch(success(response));
        })
        .catch((error) => {
            // handle error
            dispatch(failure(error.toString()));
        });

    function request() {
        return { type: "FILTERED_COURSES_REQUEST" };
    }

    function success(response) {
        return { type: "FILTERED_COURSES_SUCCESS", payload: response };
    }

    function failure(error) {
        return { type: "FILTERED_COURSES_FAILURE", payload: error };
    }
};

export const setCourseName = (courseName) => ({
    type: "SET_COURSE_NAME",
    payload: courseName,
});

export const setCourseProgress = (courseProgress) => ({
    type: "SET_COURSE_PROGRESS",
    payload: courseProgress,
});

export const setShowEvaluationTestAction = (showEvaluationTest) => ({
    type: "SET_SHOW_EVALUATION_TEST",
    payload: showEvaluationTest,
});

export const setShowInstructionsAction = (showInstructions) => ({
    type: "SET_SHOW_INSTRUCTIONS",
    payload: showInstructions,
});

export const setSelfLearningTabAction = (selfLearningTab) => ({
    type: "SET_SELF_LEARNING_TAB",
    payload: selfLearningTab,
});

export const setCourseId = (courseId) => ({
    type: "SET_COURSE_ID",
    payload: courseId,
});
export const setTestData = (testData) => ({
    type: "SET_TEST_DATA",
    payload: testData,
});